import React from 'react';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,

} from '@ant-design/icons';
import { Layout, Button, theme } from 'antd';
const { Header, } = Layout;

export default function HeaderComponent({
  collapsed,
  setCollapsed
}: {
  collapsed: boolean;
  setCollapsed: Function
}) {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Header className='header' style={{ padding: 0, background: colorBgContainer }}>
      <Button
        type="text"
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={() => setCollapsed(!collapsed)}
        style={{
          fontSize: '16px',
          width: 64,
          height: 64,
        }}
      />
    </Header>
  )
}
